import templatesWorker from "./templatesWorker.js";
import Message from "./frontend_modules/Message";
import md5 from "crypto-js/md5";


import emojisJson from './emojis.json';

export default class socketMessenger {


    constructor() {

        this.connecting = false;
        this.connected = false;
        this.connection = null;
        this.mobileLayout = false;
        this.token = null;
        this.memcached = 0;
        this.userIDHash = null;
        this.chatServerURL = null;
        this.$messengerWindow = null;
        this.templatesWorker = new templatesWorker();
        this.newMessengerImageListener = null;
        this.currentConversationID = null;
        this.$conversationsHolder = null;
        this.$conversationsMainHolder = null;
        this.nextConversationsPageRequested = false;
        this.lastConversationsRequestIDs = null;
        this.allConversations = null;
        this.initDone = false;
        this.newConversationRequested = false;
        this.notificationsListener = null;
        this.currentUser = null;
        this.connectionAttempts = 0;
        this.maxconnectionAttempts = 5;
        this.currentConversationFilter = null;
        this.currentSearchUsername = null;
        this.conversationSearchSequence = null;
        this.replyMode = false;
        this.lastScrolltop = 0;
        this.messageIdToHighlight = null;
        this.currentLastMessageId = null;
        this.availableConversationFilter = ['all', 'unread', 'read', 'notanswered', 'answered', 'mycontactattempts', 'subscriber', 'follower', 'favorites', 'useronline'];

        this.createListener();
        this.getConnectionData();
    }


    handleConversationsScroll() {
        let mySelf = this;
        let mainConversationsHolderHeight = this.$conversationsMainHolder.innerHeight();
        let conversationsHolderHeight = this.$conversationsHolder.outerHeight();
        let maxScrollHeight = Math.floor(conversationsHolderHeight - mainConversationsHolderHeight);
        let currentScrollHeight = this.$conversationsMainHolder.scrollTop();
        let preloadHeight = 30;

        if (currentScrollHeight > (maxScrollHeight - preloadHeight)) {
            if (!this.nextConversationsPageRequested) {
                this.requestConversationsList();
            }
        }
    }

    initComponents() {

        if (!this.initDone) {
            let mySelf = this;

            $(document).on("notification:read", function (event, data) {
                mySelf.requestNotificationsCount();
            });

            $(document).on("bestoffers:read", function (event, data) {
                mySelf.requestBestOffersCount();
            });

            let $messengerWindow = $('#page-messenger');
            if ($messengerWindow.length == 1) {
                this.$messengerWindow = $messengerWindow;
            } else {
                return;
            }

            this.$conversationsMainHolder = $('[data-type="conversations_main_holder"]');
            this.$conversationsHolder = $('[data-type="conversations_holder"]');


            const debouncedConversationscroll = debounce(function () {
                mySelf.handleConversationsScroll();
            }, 100);

            this.$conversationsMainHolder.on('scroll', function () {
                debouncedConversationscroll();
            });

            this.$conversationsHolder.on('scroll', function () {
                debouncedConversationscroll();
            });


            $(document).on("content:resized", function () {
                    mySelf.checkMobileLayout();
                }
            );

            $(document).on("message:setread", function (event, data) {
                mySelf.setreadConversationMessage(data.id);
            });
            $(document).on("message:cancelpurchase", function (event, data) {
                mySelf.cancelPurchase(data.id);
            });

            $(document).on("conversation:deleteMessage", function (event, data) {
                mySelf.deleteConversationMessage(data.msg, data.conversationId);
            });


            $(document).on('Messenger:newMessengerImage', function (event, data) {
                mySelf.newMessengerImageListener(event, data);
            });

            $(document).on('message:reaction', function (event, data) {
                const originalEvent = data.originalEvent;
                const messageId = data.contentId;
                const conversationId = data.convId;
                let selectedEmoji = originalEvent.emoji;

                if (selectedEmoji) {
                    mySelf.createMessageReaction(messageId, selectedEmoji, conversationId);
                }
            });

            $(document).on('reaction:clicked', function (event, data) {
                const messageId = data.contentId;
                const clickedEmoji = data.clickedReaction;
                const conversationId = data.conversationId;

                if (clickedEmoji) {
                    mySelf.handleClickedMessageReaction(messageId, clickedEmoji, conversationId);
                }
            });

            $(document).on('message:send_gif', function (event, data) {
                const conversationId = data.contentId;
                const sendTo = data.sendTo;
                const gif = data.gif;

                if (gif) {
                    mySelf.sendGif(conversationId, sendTo, gif);
                }
            });

            $(document).on('conversation:reset_search', function (event, data) {
                const conversationId = data.conversationId;

                if (conversationId) {
                    mySelf.resetConversationSearch(conversationId);
                }
            });

            $(document).on('conversation:submit_search', function (event, data) {
                const conversationId = data.conversationId;
                const searchSequence = data.searchSequence;
                mySelf.conversationSearchSequence = searchSequence;

                if (searchSequence) {
                    let conversationHolder = $('#conversation_' + conversationId);
                    mySelf.reloadConversation(conversationHolder, conversationId);
                }
            });

            this.checkMobileLayout();
            this.initDone = true;
            this.initConversationsFilter();
            this.initSearchToggle();
            this.addCloseConversationListener();
        }
        // User befindet sich im Messenger, Messengerfunktionalität starten
        this.requestConversationsList();

    }

    initConversationsFilter() {

        let mySelf = this;
        let $filterButtons = $('[data-type="conversation_filter"]');

        if ($filterButtons.length > 0) {
            $filterButtons.on('click', function () {
                $filterButtons.find('button').removeClass('active');
                let filter = $(this).data('value');
                $(this).find('button').addClass('active');
                mySelf.setConversationsFilter(filter);
            });
        }

        // init search
        let $checkBoxFilter = $('[data-type="checkbox-filter"]');

        if ($checkBoxFilter.length > 0) {
            $checkBoxFilter.on('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                let $searchInput = $('[data-type="search-bar"]');
                mySelf.currentSearchUsername = $searchInput.val();
                mySelf.resetConversationsList();
                mySelf.requestConversationsList();
            });
        }
    }

    setConversationsFilter(filter) {

        if (this.availableConversationFilter.includes(filter)) {
            this.currentConversationFilter = filter;
            this.resetConversationsList();
            this.requestConversationsList();
        }

    }

    resetConversationsList() {
        if (this.$conversationsHolder == null) {
            return false;
        }
        this.allConversations = null;
        this.$conversationsMainHolder.attr('data-md5', '');
        this.$conversationsHolder.html('');
    }

    resetSearchResult() {
        this.currentSearchUsername = null;
        this.resetConversationsList();
        this.requestConversationsList();
    }

    initSearchToggle() {
        const mySelf = this;

        $(document).find('button[data-clear]').on('click', function () {
            mySelf.resetSearchResult();
        });
    }

    createListener() {
        let mySelf = this;

        this.notificationsListener = function () {
            mySelf.requestNotificationsCount();
        };

        this.newMessengerImageListener = function (event, data) {
            let conversationID = data.conversationID;
            let uploadMessage = data.uploadMessage;
            let imageID = data.imageID;
            let uploadPrice = data.uploadPrice;
            let uploadCurrency = data.uploadCurrency;

            let currentMd5Hash = md5(uploadMessage.trim());
            mySelf.sentNewImage(conversationID, imageID, uploadMessage, uploadPrice, uploadCurrency, currentMd5Hash.toString());

            if (mySelf.replyMode) {
                let $conversationHolder = $('#conversation_' + conversationID);
                mySelf.replyModeOff($conversationHolder);
            }
        };
    }


    checkMobileLayout() {
        if (this.getCurrentFullScreenElement() != null) {
            return false;
        }

        let minDesktopWidth = 992;
        let currentWidth = $(window).width();

        if (minDesktopWidth > currentWidth) {
            this.mobileLayout = true;
        } else {
            this.mobileLayout = false;
            $('#conversations-main-holder').removeClass('hidden');
            $('#messenger-friendlist').removeClass('hidden');
        }
    }


    getConnectionData() {
        let mySelf = this;
        let tokenUrl = $('meta[name="tokenUrl"]').attr('content');

        if (tokenUrl != undefined) {
            let jqxhr = $.post(tokenUrl, function () {
            }, 'json')
                .done(function (jsonData) {
                    if (jsonData.token != undefined && jsonData.chatServerURL != undefined) {

                        mySelf.token = jsonData.token;
                        mySelf.chatServerURL = jsonData.chatServerURL;

                        if (jsonData.mc != undefined) {
                            mySelf.memcached = jsonData.mc;
                        }

                        if (jsonData.hash != undefined) {
                            mySelf.userIDHash = jsonData.hash;
                        }

                        mySelf.initSocketConnection();
                    }
                });
        }
    }


    initSocketConnection() {

        if (this.connecting) {
            return;
        }

        this.connectionAttempts++;

        this.connecting = true;

        if (this.chatServerURL == null || this.token == null) {
            this.getConnectionData();
        }

        let mySelf = this;
        let connectionUrl = this.chatServerURL + "?token=" + this.token + "&mc=" + this.memcached;

        if (this.userIDHash != null) {
            connectionUrl += "&hash=" + this.userIDHash;
        }

        console.log('Connecting to ' + connectionUrl);

        this.connection = new WebSocket(connectionUrl);

        this.connection.onopen = function () {
            mySelf.connected = true;
            mySelf.connecting = false;
        };

        this.connection.onclose = function () {
            console.log('WebSocket closed ');
            mySelf.resetMessengerData();
        };

        this.connection.onerror = function (error) {
            console.log('WebSocket Error ');
            console.error(error);
            mySelf.resetMessengerData();
        };

        this.connection.onmessage = function (e) {
            mySelf.parseServerResponse(e.data);
        };
    }

    reloadConversations() {
        this.allConversations = null;
        let $conversationsHolder = $('[data-type="conversations_holder"]');
        $conversationsHolder.html('');
        this.requestConversationsList();
    }

    closeConversation(jsonData = null) {
        let conversationId = this.currentConversationID;
        if (jsonData != null) {
            conversationId = jsonData.conversationID;
        }

        let $conversation = $('#conversation_' + conversationId);
        if ($conversation.length == 1) {
            $conversation.remove();
        }
        let url = new URL(window.location);
        if (url.hash != "") {
            let newUrl = url.href.replace(url.hash, "");
            window.location = newUrl + "#";
        }
        if (this.mobileLayout) {
            this.closeMobileConversation();
        }
    }

    resetConversationSearch(conversationID) {
        this.conversationSearchSequence = null;
        let conversationHolder = $('#conversation_' + conversationID);
        this.reloadConversation(conversationHolder, conversationID);
    }

    reloadConversation($conversationHolder, conversationID) {
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
        $messagesContainer.html('');
        this.requestConversationData(conversationID);
        this.lastScrolltop = $messagesContainer.scrollTop();
    }

    resetMessengerData() {

        $(document).off('Messenger:newMessengerImage', this.newMessengerImageListener);
        let mySelf = this;
        mySelf.connected = false;
        mySelf.connection = null;
        mySelf.connecting = false;

        if (this.connectionAttempts >= this.maxconnectionAttempts) {
            console.error("max Attempts reached");
            return;
        }

        setTimeout(function () {
                mySelf.initSocketConnection();
            }, 1000
        )
    }

    parseServerResponse(serverResponse) {
        let mySelf = this;
        const jsonObj = JSON.parse(serverResponse);

        switch (jsonObj.type) {

            case "connectionstate":
                if (jsonObj.payload.state === "open") {
                    this.connected = true;
                    this.currentUser = jsonObj.payload.userData;
                    // Verbindung erfolgreich aufgebaut und Response vom Server erhalten
                    mySelf.initComponents();
                } else if (jsonObj.payload.state === "close") {
                    this.connection.close();
                } else if (jsonObj.payload.state === "reconnect") {
                    this.connection.close();
                }
                break;

            case "conversationsList":
                this.updateConversationsList(jsonObj.payload, jsonObj.md5);
                $(document).trigger("content:loaded");
                this.nextConversationsPageRequested = false;
                break;

            case "modalTrigger":
                this.openModal(jsonObj.payload.url);
                break;

            case "conversationData":
                this.updateConversationData(jsonObj.payload);
                $(document).trigger("content:loaded");
                break;

            case "updateBalance":
                this.updateBalance(jsonObj.payload.balance);
                break;

            case "markMessageRead":
                $(document).trigger("message:markread", {
                    id: jsonObj.payload.msgID
                });
                break;

            case "conversationUnreadUpdate":
                this.updateConversationUnreadMessagesCount(jsonObj.payload);
                break;

            case "msgstatus":
                this.updateUnreadMessagesCount(jsonObj.payload);
                break;

            case "notificationsstatus":
                this.updateUnreadNotificationsCount(jsonObj.payload);
                break;

            case "bestoffersstatus":
                this.updateUnreadBestOffersCount(jsonObj.payload);
                break;

            case "conversationStatus":
                this.showUserTyping(jsonObj.payload);
                break;

            case "closeConversation":
                this.closeConversation(jsonObj.payload);
                break;

            case "reloadConversations":
                this.reloadConversations();
                break;

            case "updateAvailable":
                this.workOnUpdates(jsonObj.payload);
                break;

            case "newConversationData":
                this.createNewConversation(jsonObj.payload);
                $(document).trigger("content:loaded");
                break;

            case "hideMessage":
                this.hideConversationMessage(jsonObj.payload.msgID);
                break;

            case "conversationMessage":
                this.replaceConversationMessage(jsonObj.payload.message);
                break;

            case "notice":
                //    alert('notice');
                break;

            case "error":
                this.displayError(jsonObj.payload.title, jsonObj.payload.subtitle, jsonObj.payload.body);
                break;

            case "messageconfirm":
                this.resetMessageText(jsonObj.payload.conversationID, jsonObj.payload.md5);
                break;

        }
    }

    openModal(url) {
        $(document).trigger('modal:open', {
            contentUrl: url
        });
    }

    resetMessageText(conversationID, md5Hash) {
        let $conversationHolder = $('#conversation_' + conversationID);

        if ($conversationHolder.length == 0) {
            let $conversationHolder = $('#conversation_new');
        }

        if ($conversationHolder.length == 1) {
            let $form = $conversationHolder.find('[data-type="messageform"]').first();
            let $textarea = $form.find('textarea').first();
            let currentTxt = $textarea.val().trim();
            let currentMd5Hash = md5(currentTxt);

            if (currentMd5Hash.toString() == md5Hash) {
                $textarea.val('');
                $textarea.trigger('change');
                $conversationHolder.attr('id', 'conversation_' + conversationID);
            }
        }
    }


    workOnUpdates(payload) {
        switch (payload.data.type) {
            case "conversation":
                if (payload.data.id == this.currentConversationID) {
                    let maxMessageId = this.getMaxLoadedMessageId();
                    this.requestConversationData(payload.data.id, maxMessageId);
                } else {
                    this.requestSingleConversationListData(payload.data.id);
                }
                break;
        }
    }

    updateBalance(currentBalance) {
        $('[data-type="usercredit"]').html(currentBalance);
    }

    displayError(title, subtitle, body) {
        $(document).trigger("toast:show", {
            title: title,
            subtitle: subtitle,
            body: body,
            type: "error",
        });
    }

    replaceConversationMessage(message) {
        if (this.$messengerWindow == null) {
            return;
        }
        let mySelf = this;
        let conversationId = message.conversation_id;

        let $conversationHolder = $('#conversation_' + message.conversation_id);
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
        let $messageContainer = $messagesContainer.find('[data-message-id="' + message.id + '"]').first();

        let tmpHtml = "";
        tmpHtml = this.templatesWorker.loadMessageTemplate(this.currentUser, $messagesContainer, message, tmpHtml, true);

        $messageContainer.replaceWith(tmpHtml);

        $('[data-type="message"][data-state="init"]').each(function () {
            let MessageObj = new Message(this);
        });

        // re-init reply
        $('.conversation_reply').off('click');
        $('.conversation_reply').on('click', function (event) {
                let message = $(this).closest('message');
                mySelf.initMessageReply($conversationHolder, conversationId, message);
            }
        );

        $(document).trigger("content:loaded");
    }

    hideConversationMessage(msgID) {
        let $message = $('[data-message-id="' + msgID + '"]');
        if ($message.length > 0) {
            if ($message.attr('own') == 1) {
                $message.find('.js-message').html($message.attr('data-deleted-own-txt'));
            } else {
                $message.find('.js-message').html($message.attr('data-deleted-txt'));
            }
            $message.find('.js-message-image').remove();
            $message.remove();
        }
    }

    showUserTyping(jsonData) {
        let $conversationHolder = $('#conversation_' + jsonData.conversationID);

        if ($conversationHolder.length == 1) {
            let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
            if (jsonData.action === "typing") {
                this.templatesWorker.loadUserTypingTemplate($messagesContainer, jsonData.userData, jsonData.content);
            } else {
                let $typingContainer = $conversationHolder.find('[data-user-id="' + jsonData.userData.userID + '"]').first();
                $typingContainer.remove();
            }
        }
    }


    getFilteredConversations(conversations1, conversations2) {

        let filteredConversations1 = [];
        let filteredConversations2 = [];

        conversations1.every(function (conversation1) {
            let useConversation1 = true;
            conversations2.every(function (conversation2) {
                if (conversation1.id == conversation2.id) {
                    if (conversation1.md5 != conversation2.md5) {
                        useConversation1 = false;
                        return false;
                    }
                }
                return true;
            });
            if (useConversation1) {
                filteredConversations1.push(conversation1);
            }
            return true;
        });

        conversations2.every(function (conversation2) {
            let useConversation2 = true;
            filteredConversations1.every(function (conversation1) {
                if (conversation1.id == conversation2.id) {
                    useConversation2 = false;
                    return false;
                }
                return true;
            });
            if (useConversation2) {
                filteredConversations1.push(conversation2);
            }
            return true;
        });
        return filteredConversations1;
    }

    updateConversationsList(jsonData, newMd5Hash) {
        if (this.$conversationsMainHolder == null) {
            // Bugfix, hier muss insgesamt die Struktur verbessert werden
            return false;
        }
        let mySelf = this;
        let foundConversation = false;
        let participantID = null;
        let url = new URL(window.location);
        if (url.hash != "") {
            let hashString = url.hash.replace("#", "");
            if (hashString.length > 0) {
                participantID = hashString;
            }
        }

        let currentMd5Hash = this.$conversationsMainHolder.attr('data-md5');

        if (currentMd5Hash == newMd5Hash) {
            return;
        }

        this.$conversationsMainHolder.attr('data-md5', newMd5Hash);

        if (jsonData.conversations !== undefined && jsonData.conversations !== null) {
            if (this.allConversations == null) {
                this.allConversations = jsonData.conversations;
            } else {
                let filteredConversations = this.getFilteredConversations(this.allConversations, jsonData.conversations);
                this.allConversations = filteredConversations;
            }

            let compareConversations = function compare(conversationsA, conversationsB) {
                if (parseInt(conversationsA.order_by) < parseInt(conversationsB.order_by)) {
                    return 1;
                }
                if (parseInt(conversationsA.order_by) > parseInt(conversationsB.order_by)) {
                    return -1;
                }
                return 0;
            }


            this.allConversations.sort(compareConversations);

            let pos = 0;
            this.allConversations.forEach(function (conversation) {

                let participants = conversation.participants;
                let $conversationDomObj = $('conversationentry[data-id="' + conversation.id + '"]').first();

                if ($conversationDomObj.length == 0) {
                    $conversationDomObj = $("#js-conversation_entry_tpl").contents().clone();
                    $conversationDomObj.on('click', function () {
                        mySelf.viewConversation(conversation);
                        window.location.href = window.location.href.substr(0, window.location.href.indexOf('#')) + '#' + participants[0].userID;
                    });
                }

                if ($conversationDomObj.attr('data-pos') != pos) {
                    if (pos == 0) {
                        mySelf.$conversationsHolder.prepend($conversationDomObj);
                    } else {
                        let prevPos = pos - 1;
                        let $previousDomObj = $('conversationentry[data-pos="' + prevPos + '"]').first();
                        $previousDomObj.after($conversationDomObj);
                    }
                    $conversationDomObj.attr('data-pos', pos);
                }

                if ($conversationDomObj.attr('data-md5') != conversation.md5) {
                    $conversationDomObj.attr('data-id', conversation.id);

                    $conversationDomObj.attr('data-md5', conversation.md5);
                    $conversationDomObj.attr('data-participant-id', participants[0].userID);

                    mySelf.templatesWorker.fillUserData($conversationDomObj, participants[0].userID, participants[0].username, participants[0].avatar, participants[0].usertype, participants[0].isOnline, conversation.last_message_time, participants[0].verified, participants[0].subscriber, participants[0].follower);
                    let $messagesBubble = $conversationDomObj.find('[data-type="messagescount"]');

                    if (conversation.messagesCount > 0) {
                        $messagesBubble.html(conversation.messagesCount);
                        $messagesBubble.removeClass('hidden');
                    } else {

                        if (conversation.unread == 1) {
                            $messagesBubble.removeClass('hidden');
                            $messagesBubble.html(' ');
                        } else {
                            $messagesBubble.addClass('hidden');
                        }
                    }
                    let $priceContainer = $conversationDomObj.find('[data-type="message-price-container"]');
                    if (conversation.tip == 1) {
                        $priceContainer.removeClass('hidden');
                        $priceContainer.find('[data-type="message-price"]').html(conversation.paid_amount);
                    } else {
                        $priceContainer.addClass('hidden');
                    }

                    let $pinIcon = $conversationDomObj.find('[data-type="pin-icon"]');
                    if (conversation.pinned == 1) {
                        $pinIcon.removeClass('hidden');
                    } else {
                        $pinIcon.addClass('hidden');
                    }

                    $conversationDomObj.find('.js-content').html(conversation.content);

                    let $imageIcon = $conversationDomObj.find('[data-type="image-icon"]');
                    if (conversation.isImage == 1) {
                        $imageIcon.removeClass('hidden');
                    } else {
                        $imageIcon.addClass('hidden');
                    }
                }


                if (participantID != null && participantID == participants[0].userID) {
                    mySelf.viewConversation(conversation);
                }

                pos++;
            });

            if (jsonData.conversations.length > 0) {
                let mainConversationsHolderHeight = this.$conversationsMainHolder.innerHeight();
                let contentHeight = this.$conversationsHolder[0].scrollHeight;

                if (mainConversationsHolderHeight > contentHeight) {
                    // Lädt weitere Einträge nach, falls die Liste nicht vollständig gefüllt wurde und der User noch nicht scrollen kann
                    this.requestConversationsList();
                }
            }
            if (this.allConversations.length > 0) {

                $('messenger').removeClass('hidden');
                $('#conversations-holder').removeClass('hidden');

                if (this.mobileLayout) {
                    $('#no-conversations_mobile').addClass('hidden');
                } else {
                    $('#no-conversations').addClass('hidden');
                }

            }
        } else {
            if (this.allConversations == null || this.allConversations.length == 0) {

                $('#conversations-holder').addClass('hidden');

                if (this.mobileLayout) {
                    $('#no-conversations_mobile').removeClass('hidden');
                } else {
                    $('#no-conversations').removeClass('hidden');
                }

            } else {

                $('#conversations-holder').removeClass('hidden');

                if (this.mobileLayout) {
                    $('#no-conversations_mobile').addClass('hidden');
                } else {
                    $('#no-conversations').addClass('hidden');
                }
            }

        }

        if (participantID != null && this.currentConversationID == null) {
            this.requestNewConversation(participantID);
        }

    }


    updateConversationUnreadMessagesCount(jsonData) {
        let unreadAmountInt = parseInt(jsonData.unreadAmount);

        let $conversationElement = $('[data-id="' + jsonData.conversationID + '"]').first();
        if (unreadAmountInt == 0) {
            $conversationElement.find('[data-type="messagescount"]').html('');
        } else {
            $conversationElement.find('[data-type="messagescount"]').html(unreadAmountInt);
        }
    }

    updateUnreadMessagesCount(jsonData) {
        let messagesCountInt = parseInt(jsonData.unreadMessages);

        if (messagesCountInt > 0) {
            $(".nav-unread-messages").html(messagesCountInt);
            $(".nav-unread-messages").removeClass("hidden");
        } else {
            $(".nav-unread-messages").html("");
            $(".nav-unread-messages").addClass("hidden");
        }
    }

    updateUnreadNotificationsCount(jsonData) {
        let notificationsCountInt = parseInt(jsonData.unreadNotifications);

        if (notificationsCountInt > 0) {
            $(".nav-unread-notifications").html(notificationsCountInt);
            $(".nav-unread-notifications").removeClass("hidden");
        } else {
            $(".nav-unread-notifications").html("");
            $(".nav-unread-notifications").addClass("hidden");
        }
    }

    updateUnreadBestOffersCount(jsonData) {
        let bestOffersCount = parseInt(jsonData.unreadBestOffers);

        if (bestOffersCount > 0) {
            $('[data-type="unread-bestoffers-amount"]').html(bestOffersCount);
            $('[data-type="unread-bestoffers-amount"]').removeClass("hidden");
        } else {
            $('[data-type="unread-bestoffers-amount"]').html("");
            $('[data-type="unread-bestoffers-amount"]').addClass("hidden");
        }
    }

    /*********CONVERSATIONS*********/
    viewConversation(conversationData) {
        let conversationID = conversationData.id;
        this.currentLastMessageId = conversationData.last_message_id;

        if (this.currentConversationID != conversationID) {
            // conversationSearchSequence nur dann zurücksetzen, wenn conversation gewechselt wurde
            this.conversationSearchSequence = null;
        }
        this.currentConversationID = conversationID;
        let $conversationsContainer = $('#conversations-holder');
        let $conversation = $('#conversation_' + conversationID);

        if ($conversation.length == 0) {
            $conversation = this.templatesWorker.createNewConversation($conversationsContainer, conversationID);
        }

        if ($conversation.hasClass('hidden')) {
            this.cleanConversationContainer(conversationID);
            this.requestConversationData(conversationID);
        }

        $('#conversations-holder').children().addClass('hidden');
        $conversation.removeClass('hidden');

        if (this.mobileLayout) {
            $('#conversations-main-holder').removeClass('hidden');
            $('#messenger-friendlist').addClass('hidden');
        }

        $(document).trigger("content:loaded");
    }

    closeMobileConversation() {
        $('#conversations-main-holder').addClass('hidden');
        $('#messenger-friendlist').removeClass('hidden');
    }

    addCloseConversationListener() {
        let mySelf = this;

        window.addEventListener('popstate', function handler() {
            let url = new URL(window.location);
            if (url.hash == '') {
                if (mySelf.currentConversationID != null) {
                    mySelf.closeConversation();
                }
            }
        });
    }

    updateConversationData(jsonData) {
        if (jsonData.data === null) {
            return;
        }
        let mySelf = this;
        let conversationID = jsonData.data.id;
        let firstMessageID = '';
        let $conversationHolder = $('#conversation_' + conversationID);
        let $header = $conversationHolder.find('.js-header').first();
        let appendMessages = false;

        if (jsonData.data.firstMessageID != undefined) {
            firstMessageID = jsonData.data.firstMessageID;
        }

        if (jsonData.append != undefined && jsonData.append == 1) {
            appendMessages = true;
        }

        if ($conversationHolder.length == 0) {
            // Konversation bisher nicht geladen
            return;
        }

        if ($conversationHolder.hasClass('hidden')) {
            return;
        }

        let $pinButton = null;
        let $unPinButton = null;
        let $deleteButton = null;
        let $unReadButton = null;
        let $blockButton = null;
        let $unBlockButton = null;
        let $conversationSearchContainer = null;
        let $fanCategoriesButton = null;
        let $notesButton = null;

        if ($header.length == 0) {
            // Diese Konversation wurde bisher nicht geladen, daher neu aus dem Template laden.
            $header = this.templatesWorker.loadConversationTemplate($conversationHolder, conversationID);

            this.initMessageForm($conversationHolder, conversationID, jsonData.data.participants[0]);
        } else {
            this.updateMessageForm($conversationHolder, jsonData.data.participants[0]);
        }

        let $backButton = $header.find('[data-btn="back_btn"]');

        if ($backButton.length == 1) {
            $backButton.on('click', function () {
                    mySelf.closeConversation();
                }
            );
        }

//TODO Optimierung für die Initialisieurng der Buttons
        $pinButton = $header.find('[data-btn="pin_button"]');
        $unPinButton = $header.find('[data-btn="unpin_button"]');
        $deleteButton = $header.find('[data-btn="delete_button"]');
        $unReadButton = $header.find('[data-btn="unread_button"]');
        $blockButton = $header.find('[data-btn="block_button"]');
        $unBlockButton = $header.find('[data-btn="unblock_button"]');
        $fanCategoriesButton = $header.find('[data-btn="fan_categories"]');
        $notesButton = $header.find('[data-btn="notes_button"]');

        $pinButton.on('click', function () {
            mySelf.pinConversation();
        });
        $unPinButton.on('click', function () {
            mySelf.unPinConversation();
        });
        $unReadButton.on('click', function () {
            mySelf.unreadConversation();
        });

        let blockUrl = $blockButton.attr('data-url');
        let unblockUrl = $unBlockButton.attr('data-action-url');

        let userID = jsonData.data.participants[0].userID;

        blockUrl = blockUrl.replace('hashID', userID);
        unblockUrl = unblockUrl.replace('hashID', userID);

        $blockButton.attr('data-url', blockUrl);
        $unBlockButton.attr('data-action-url', unblockUrl);

        if ($blockButton.attr('data-state') == 'preinit') {
            $blockButton.attr('data-state', 'init');
        }

        if ($unBlockButton.attr('data-state') == 'preinit') {
            $unBlockButton.attr('data-state', 'init');
        }

        if ($fanCategoriesButton.length == 1) {
            let fanCategoriesUrl = $fanCategoriesButton.attr('data-url');
            fanCategoriesUrl = fanCategoriesUrl.replace('hashID', userID);
            fanCategoriesUrl = fanCategoriesUrl.replace('user_name', jsonData.data.participants[0].username);
            $fanCategoriesButton.attr('data-url', fanCategoriesUrl);

            if ($fanCategoriesButton.attr('data-state') == 'preinit') {
                $fanCategoriesButton.attr('data-state', 'init');
            }

            if (jsonData.data.participants[0].usertype != 1) {
                $fanCategoriesButton.parent().remove();
            }
        }

        if ($notesButton.length == 1) {
            let notesData = $notesButton.attr('data-modaldata');
            notesData = notesData.replace('hashID', userID);
            $notesButton.attr('data-modaldata', notesData);

            if ($notesButton.attr('data-state') == 'preinit') {
                $notesButton.attr('data-state', 'init');
            }

            if (jsonData.data.participants[0].usertype != 1) {
                $notesButton.parent().remove();
            }
        }

        $conversationSearchContainer = $header.find('[data-type="conversation-search-container"]');
        if ($conversationSearchContainer.length == 1) {
            $conversationSearchContainer.attr('data-target-id', conversationID);

            if ($conversationSearchContainer.attr('data-state') == 'pre_init') {
                $conversationSearchContainer.attr('data-state', 'init');
            }
        }

        let $messageForm = $conversationHolder.find('[data-type="messageform"]').first();
        if ($messageForm.length == 1) {
            let messageFormHeight = $messageForm.innerHeight();
            if (messageFormHeight > 0) {
                $('html').css('--height-messenger-form', messageFormHeight + 'px');
            }
        }


        if (jsonData.data.pinned == 1) {
            $pinButton.addClass('hidden');
            $unPinButton.removeClass('hidden');
        } else {
            $pinButton.removeClass('hidden');
            $unPinButton.addClass('hidden');
        }

        if (jsonData.data.participants[0].admin == 1) {
            $blockButton.addClass('hidden');
            $unBlockButton.addClass('hidden');
            $unBlockButton.parent().addClass('hidden');
            $deleteButton.parent().remove();
        } else {
            if (jsonData.data.participants[0].blocked) {
                $blockButton.addClass('hidden');
                $unBlockButton.removeClass('hidden');
            } else {
                $unBlockButton.addClass('hidden');
                $blockButton.removeClass('hidden');
            }

            $deleteButton.on('click', function () {
                mySelf.deleteConversation();
            });
        }


        jsonData.data.participants.forEach(function (participant) {
            mySelf.templatesWorker.fillUserData($header, participant.userID, participant.username, participant.avatar, participant.usertype, participant.isOnline, participant.user_last_activity_at, participant.verified, participant.subscriber, participant.follower, participant.payments);
        });

        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();

        if ($messagesContainer.length == 1) {
            let maxMessageID = null;
            let html = $messagesContainer.html();
            let tmpHtml = "";
            jsonData.messages.forEach(function (message) {
                    if (message.type == "msg") {
                        tmpHtml = mySelf.templatesWorker.loadMessageTemplate(mySelf.currentUser, $messagesContainer, message, tmpHtml);
                        maxMessageID = message.id;
                    } else if (message.type == "date") {
                        tmpHtml = mySelf.templatesWorker.loadConversationDateTemplate($messagesContainer, message, tmpHtml);
                    }
                }
            );

            if (!appendMessages && firstMessageID.length > 0) {
                // Ist die ID length > 0, handelt es sich um ältere Nachrichten, welche oben angefügt werden sollen
                // html = tmpHtml + html;
                $messagesContainer.prepend(tmpHtml);
            } else {
                //  html = html + tmpHtml;
                $messagesContainer.append(tmpHtml);
            }
            // update mySelf.lastScrolltop position for prevent false scrolling event
            mySelf.lastScrolltop = $messagesContainer.scrollTop();

            // $messagesContainer.html(html);

            // Messages initialisieren

            $('[data-type="message"][data-state="init"]').each(function () {
                let MessageObj = new Message(this);
            });


            if (firstMessageID.length > 0) {
                // Wenn der Benutzer das "Gehe zu Nachricht"-Feature benutzt hat und danach nach unten gescrollt hat,
                // werden die neueren Nachrichten geholt und unten angehängt. In diesem Fall müssen wir nicht
                // zur alten ersten Nachricht scrollen
                if (!appendMessages) {
                    // nur dann scrollen, wenn es keine ältere Nachrichten sind
                    let $oldFirstMessage = $messagesContainer.find("[data-message-id='" + firstMessageID + "']").first();
                    if ($oldFirstMessage.length == 1) {
                        let newPosition = $oldFirstMessage.position().top;
                        $messagesContainer.scrollTop(newPosition);
                    }
                }
            } else {
                let scrollHeight = $messagesContainer[0].scrollHeight + 1000; // In manchen Fällen wird nicht ausreichend tief durchgescrollt.
                $messagesContainer.scrollTop(scrollHeight);
            }

            // todo: replies optimieren, umbauen
            // Um mehrfache Ausführungen und unbeabsichtigte Auslösungen in anderen Konversationen zu verhindern,
            // wird der Klick-Event-Handler zuerst entfernt und dann erneut hinzugefügt.
            $('.conversation_reply').off('click');
            $('.conversation_reply').on('click', function (event) {
                    let message = $(this).closest('message');
                    mySelf.initMessageReply($conversationHolder, conversationID, message);
                }
            );

            $(document).off('click', '.message_reply--group');
            $(document).on('click', '.message_reply--group', function (event) {
                event.stopPropagation();
                let messageId = $(this).data('reply-to-message-id');

                if (messageId.length > 0) {
                    let $searchMessageContainer = $messagesContainer.find("[data-message-id='" + messageId + "']").first();
                    mySelf.messageIdToHighlight = messageId;

                    if ($searchMessageContainer.length == 0) {
                        $messagesContainer.html('');
                        mySelf.requestNextMessages(conversationID, messageId);
                    }

                    if ($searchMessageContainer.length == 1) {
                        mySelf.highlightMessage($messagesContainer);

                        let newPosition = $searchMessageContainer.offset().top;
                        let containerPosition = $messagesContainer.offset().top;
                        let scrollToPosition = newPosition - containerPosition;

                        $messagesContainer.animate({
                            scrollTop: $messagesContainer.scrollTop() + scrollToPosition
                        }, 600);
                    }
                }
            });

            if (mySelf.lastScrolltop == 0) {
                mySelf.lastScrolltop = $messagesContainer.scrollTop();
            }

            let $gotoLastMessageBtn = $conversationHolder.find('[data-id="goto-last-msg-btn"]').first();

            $messagesContainer.off('scroll');
            $messagesContainer.on('scroll', debounce(function () {
                let currentScrollTop = $messagesContainer.scrollTop();

                if (currentScrollTop > mySelf.lastScrolltop) {
                    // Scrolling down
                    mySelf.handleScrolltopBottom(conversationID, $messagesContainer);
                    mySelf.lastScrolltop = $messagesContainer.scrollTop();
                } else {
                    // Scrolling up
                    mySelf.handleScrolltopTop(conversationID, $messagesContainer);
                }

                mySelf.handleGoToEndButton($messagesContainer, $gotoLastMessageBtn);
                if (currentScrollTop > 0) {
                    mySelf.lastScrolltop = currentScrollTop;
                }
            }, 100));

            if (!appendMessages) {
                this.handleScrolltopTop(conversationID, $messagesContainer);
            }
        }

        this.highlightMessage($messagesContainer);
    }

    highlightMessage($messagesContainer) {
        if (this.messageIdToHighlight != null) {
            $messagesContainer.find('.highlight').removeClass('highlight');

            let $searchMessageContainer = $messagesContainer.find("[data-message-id='" + this.messageIdToHighlight + "']").first();

            if ($searchMessageContainer.length == 1) {
                let messageContainer = $searchMessageContainer.find("[data-type='message-content']").first();
                messageContainer.addClass('highlight');
                this.messageIdToHighlight = null;

                return true;
            }
        }

        return false;
    }

    cleanConversationContainer(conversationID) {
        let $conversationHolder = $('#conversation_' + conversationID);
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
        $messagesContainer.html('');
        let $gotoLastMessageBtn = $conversationHolder.find('[data-id="goto-last-msg-btn"]').first();
        $gotoLastMessageBtn.addClass('hidden');
    }

    getMaxLoadedMessageId() {
        let maxMessageId = null;
        let $conversationHolder = $('#conversation_' + this.currentConversationID);
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();

        let $lastMessage = $messagesContainer.children('.message').last();
        if ($lastMessage.length == 1) {
            let lastMessageID = $lastMessage.attr('data-message-id');

            if (lastMessageID != undefined) {
                maxMessageId = lastMessageID;
            }
        }

        return maxMessageId;
    }

    getTimestampInSeconds() {
        return Math.floor(Date.now() / 1000)
    }

    hideMessageActions() {
        let $conversationHolder = $('#conversation_' + this.currentConversationID);
        let $actionsContainer = $conversationHolder.find('actionscontainer');
        $actionsContainer.addClass("hidden");
    }

    initMessageReply($conversationHolder, conversationID, $message) {
        let mySelf = this;
        mySelf.replyMode = true;
        let $replyContainer = $conversationHolder.find('[id="message_reply_' + conversationID + '"]');

        let $closeButton = $replyContainer.find('[data-id="close-reply-btn"]');
        let $replyToUsernameHolder = $replyContainer.find('[data-id="message-owner"]');
        let $replyToMessageHolder = $replyContainer.find('[data-id="message-content"]');

        let $messageOwner = $message.data('message-username');
        let $messageContent = $message.find('[data-type="msg-content"]');

        $replyToUsernameHolder.text($messageOwner);
        $replyToMessageHolder.text($messageContent.text());

        let $replyToMessageId = $message.data('message-id');
        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        $form.find('.js-reply_message_id').val($replyToMessageId);

        let $textarea = $form.find('textarea[name="message"]').first();

        if ($textarea.length) {
            $textarea.focus();
        }

        $closeButton.on('click', function () {
            mySelf.replyModeOff($conversationHolder);
        });

        $replyContainer.removeClass('hidden');
    }

    replyModeOff($conversationHolder) {
        let mySelf = this;
        mySelf.replyMode = false;

        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        $form.find('.js-reply_message_id').val('');

        let $replyContainer = $conversationHolder.find('[data-type="messenger-reply-container"]');
        $replyContainer.addClass('hidden');
    }

    handleScrolltopTop(conversationID, $messagesContainer) {
        // ganz nach oben gescrollt, vorherige Messages laden
        if ($messagesContainer.scrollTop() == 0) {
            let $firstMessage = $messagesContainer.children('.message').first();
            if ($firstMessage.length == 1) {
                let loadingPrevious = $firstMessage.attr('data-loading-previous');
                if (loadingPrevious == 1) {
                    return;
                }
                $firstMessage.attr('data-loading-previous', 1);
                let firstMessageID = $firstMessage.attr('data-message-id');
                this.requestPreviousMessages(conversationID, firstMessageID);
            }
        }
    }

    handleScrolltopBottom(conversationID, $messagesContainer) {
        // ganz nach unten gescrollt, nächste Messages laden
        let scrollTop = $messagesContainer.scrollTop();
        let clientHeight = $messagesContainer.innerHeight();
        let scrollHeight = $messagesContainer.prop('scrollHeight');

        if ((scrollTop + clientHeight >= scrollHeight - 5)) {
            let $lastMessage = $messagesContainer.children('.message').last();
            if ($lastMessage.length == 1) {
                let loadingNext = $lastMessage.attr('data-loading-next');
                if (loadingNext == 1) {
                    return;
                }
                $lastMessage.attr('data-loading-next', 1);
                let lastMessageID = $lastMessage.attr('data-message-id');

                if (lastMessageID != undefined) {
                    this.requestNextMessages(conversationID, lastMessageID);
                }
            }
        }
    }

    // Der Button ist anfangs ausgeblendet. Er erscheint, wenn der Benutzer nach oben scrollt
    // oder die "Gehe-zu-Nachricht"-Funktion nutzt, und wird wieder ausgeblendet, wenn bis ganz
    // nach unten gescrollt wird.
    // Der Button soll nicht bei jedem Scrollen ans Ende verschwinden, da dies nicht immer die
    // letzte Nachricht im Chat ist. Andernfalls würde er sofort wieder erscheinen, wenn neue
    // Nachrichten geladen werden. Stattdessen wird der Button nur ausgeblendet, wenn die
    // letzte Nachricht (bekannt durch ihre ID) geladen ist und der Benutzer tatsächlich
    // bis zum Ende gescrollt hat.
    handleGoToEndButton($messagesContainer, $gotoLastMessageBtn) {
        let currentScrollTop = $messagesContainer.scrollTop();
        let scrollHeight = $messagesContainer.prop("scrollHeight");
        let containerHeight = $messagesContainer.outerHeight();
        let lastMessageHeight = $messagesContainer.children().last().outerHeight() || 0;

        let $lastMessageInConversation = $messagesContainer.find("[data-message-id='" + this.currentLastMessageId + "']").first();
        let lastMessageLoaded = $lastMessageInConversation.length == 1;

        if (lastMessageLoaded && (scrollHeight - (currentScrollTop + containerHeight) <= lastMessageHeight / 4)) {
            // ganz nach unten gescrollt, Button verstecken
            if (!$gotoLastMessageBtn.hasClass('hidden')) {
                $gotoLastMessageBtn.addClass('hidden');
            }
        } else if (scrollHeight - (currentScrollTop + containerHeight) > lastMessageHeight) {
            // über eine Nachricht nach oben gescrollt, Button anzeigen
            if ($gotoLastMessageBtn.hasClass('hidden')) {
                $gotoLastMessageBtn.removeClass('hidden');
            }
        }
    }


    createNewConversation(jsonData) {
        if (jsonData.data === null) {
            return;
        }
        let mySelf = this;
        let conversationID = jsonData.data.id;


        let $conversationsContainer = $('#conversations-holder');
        let $conversationHolder = this.templatesWorker.createNewConversation($conversationsContainer, conversationID);

        $('#conversations-holder').children().addClass('hidden');
        $conversationHolder.removeClass('hidden');

        let $header = this.templatesWorker.loadConversationTemplate($conversationHolder, conversationID);

        this.initMessageForm($conversationHolder, conversationID, jsonData.data.participants[0]);

        let $backButton = $header.find('[data-btn="back_btn"]');

        if ($backButton.length == 1) {
            $backButton.on('click', function () {
                    mySelf.closeConversation();
                }
            );
        }


        if (this.mobileLayout) {
            $('#conversations-main-holder').removeClass('hidden');
            $('#messenger-friendlist').addClass('hidden');
        }

        mySelf.templatesWorker.fillUserData(
            $header,
            jsonData.data.participants[0].userID,
            jsonData.data.participants[0].username,
            jsonData.data.participants[0].avatar,
            jsonData.data.participants[0].usertype,
            jsonData.data.participants[0].isOnline,
            jsonData.data.last_message_time,
            jsonData.data.participants[0].verified,
            jsonData.data.participants[0].subscriber,
            jsonData.data.participants[0].follower
        );
    }

    updateMessageForm($conversationHolder, participantData = null) {
        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        if ($form.length == 1) {
            this.setFormVisibility($conversationHolder, $form, participantData);
        }
    }

    setFormVisibility($conversationHolder, $form, participantData) {

        if (participantData.message_allowed !== undefined) {

            if (!participantData.message_allowed) {

                $form.remove();

                let $errorsHolder = $conversationHolder.find('[data-id="message-errors"]').first();

                $errorsHolder.children().each(function () {
                    if (participantData.disallow_reason == 1) {
                        if ($(this).data('id') == 'purchase-required') {
                            $(this).removeClass('hidden');
                        } else {
                            $(this).remove();
                        }
                    } else if (participantData.disallow_reason == 2) {
                        if ($(this).data('id') == 'subscription-required') {
                            $(this).removeClass('hidden');
                        } else {
                            $(this).remove();
                        }
                    } else if (participantData.disallow_reason == 3) {
                        if ($(this).data('id') == 'message-restricted') {
                            $(this).removeClass('hidden');
                        } else {
                            $(this).remove();
                        }
                    } else if (participantData.disallow_reason == 4) {
                        if ($(this).data('id') == 'message-restricted') {
                            $(this).removeClass('hidden');
                        } else {
                            $(this).remove();
                        }
                    }
                });

                return;
            }
        }

        let $priceSelect = $form.find('[data-type="msgpriceselect"]').first();

        if ($priceSelect.length == 1) {

            if (participantData.usertype != 2) {
                // Kein Creator, keine Preisauswahl
                $form.find('[data-type="msgpriceselectholder"]').remove();
            } else {
                let $options = $priceSelect.children('option');

                if (participantData.user_price != undefined) {

                    let userPrice = parseFloat(participantData.user_price);

                    if (userPrice > 0) {
                        let optionSelected = false;
                        $options.each(function (index, option) {

                            if (parseFloat($(option).val()) < userPrice) {
                                $(option).prop('disabled', true);
                            } else {
                                $(option).prop('disabled', false);
                                if (!optionSelected) {
                                    $(option).prop('selected', true);
                                    optionSelected = true;
                                }
                            }
                        });
                    } else {
                        $options.prop('disabled', false);
                        $options.first().prop('selected', true);
                    }
                } else {
                    $options.prop('disabled', false);
                    $options.first().prop('selected', true);
                }
            }
        }
    }


    initMessageForm($conversationHolder, conversationID, participantData = null) {
        let mySelf = this;
        let userIsTyping = false;
        let timer = null;

        let $form = $conversationHolder.find('[data-type="messageform"]').first();

        if ($form.length == 1) {

            this.setFormVisibility($conversationHolder, $form, participantData);

            let $gotoLastMessageBtn = $conversationHolder.find('[data-id="goto-last-msg-btn"]').first();
            $gotoLastMessageBtn.on('click', function () {
                // Der Benutzer möchte zum Ende der Nachrichten scrollen (zur neuesten Nachricht):
                // den gesamten Chat leeren, um Lücken zwischen den Nachrichten zu vermeiden, und letzte Nachrichten laden
                $gotoLastMessageBtn.addClass('hidden');
                mySelf.reloadConversation($conversationHolder, conversationID);
            });

            let $replyContainer = $conversationHolder.find('[data-type="messenger-reply-container"]').first();
            $replyContainer.attr('id', 'message_reply_' + conversationID);

            if (participantData.userID != null) {
                $form.find('.js-participant_id').val(participantData.userID);
            }

            let $textarea = $form.find('textarea').first();
            $textarea.attr('id', 'message_input_' + conversationID);
            let shiftPressed = false;

            let $uploadButton = $form.find('[data-type="modalhandler"]').first();
            let uploadButtonModalData = 'twinID=' + $textarea.attr('id');
            $uploadButton.attr('data-modaldata', uploadButtonModalData);

            let $emojiButton = $form.find('[data-type="emojipicker"]').first();
            $emojiButton.attr('data-target-id', $textarea.attr('id'));
            $emojiButton.attr('data-state', 'init');

            let $gifButton = $form.find('[data-type="gifshandler"]').first();
            $gifButton.attr('data-content-id', conversationID);
            $gifButton.attr('data-target-id', 'gif_select_' + conversationID);
            $gifButton.attr('send_to', participantData.userID);
            $gifButton.attr('data-state', 'init');

            let $gifForm = $conversationHolder.find('[data-type="messenger-giphy-container"]').first();
            $gifForm.attr('id', 'gif_select_' + conversationID);

            $textarea.on('keydown', function (event) {
                    if (event.keyCode == 16) {
                        shiftPressed = true;
                    } else if (event.keyCode == 13) {
                        if (!shiftPressed) {
                            event.preventDefault();
                        }
                    }
                }
            );

            $textarea.on('keyup', function (event) {
                    if (event.keyCode == 16) {
                        shiftPressed = false;
                    }
                    if (event.keyCode == 13) {
                        if (!shiftPressed) {
                            event.preventDefault();
                            $form.submit();
                        }
                    }
                }
            );

            $textarea.on('keyup', throttle(function (event) {

                var replaceEmojiCodesWithEmoji = function (message) {
                    return message.split(' ').map(function (piece) {

                        if (emojisJson[piece] != undefined) {
                            let emoji = emojisJson[piece][0];
                            return emoji;
                        }
                        return piece;
                    }).join(' ');
                };

                let message = $textarea.val();
                message = replaceEmojiCodesWithEmoji(message);
                $textarea.val(message);

                if (!userIsTyping) {
                    userIsTyping = true;
                    mySelf.triggerUserIsTyping(conversationID, $textarea.val());

                    timer = setTimeout(function () {
                        userIsTyping = false;
                        mySelf.triggerUserStopTyping(conversationID);
                    }, 1100);
                } else {
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        userIsTyping = false;
                        mySelf.triggerUserStopTyping(conversationID);
                    }, 1100);
                }
            }, 1000));

            $form.on("submit", function (event) {
                event.preventDefault();
                event.stopPropagation();

                mySelf.triggerUserStopTyping(conversationID);
                let formData = $(this).serialize();

                if ($textarea.val().length < 2) {
                    $(document).trigger("toast:show", {
                        title: '',
                        subtitle: '',
                        body: $textarea.attr('data-error-txt'),
                        type: "notice",
                    });
                    return false;
                }
                let currentMd5Hash = md5($textarea.val().trim());
                mySelf.sentNewMessage(conversationID, formData, currentMd5Hash.toString());
                // $textarea.val('');

                if (mySelf.replyMode) {
                    mySelf.replyModeOff($conversationHolder);
                }
            });

        }
    }


    /*********SOCKETMESSAGES*********/

    requestNotificationsCount() {
        let message = {};
        message.handler = "conversations";
        message.method = "getNotificationsCount";
        message.payload = {};
        this.sendSocketMessage(message);
    }

    requestBestOffersCount() {
        let message = {};
        message.handler = "conversations";
        message.method = "getBestOffersCount";
        message.payload = {};
        this.sendSocketMessage(message);
    }


    requestConversationsList() {
        let message = {};
        message.handler = "conversations";
        message.method = "getConversations";
        message.payload = {};
        message.payload.conversationIDs = [];
        message.payload.filter = this.currentConversationFilter;
        message.payload.searchUsername = this.currentSearchUsername;

        if (this.allConversations != null) {
            this.allConversations.forEach(function (conversation) {
                message.payload.conversationIDs.push(conversation.id);
            });
        }
        if (message.payload.lastConversationsRequestIDs == this.lastConversationsRequestIDs && this.lastConversationsRequestIDs != null) {
            console.error("same request");
            return false;
        }
        this.lastConversationsRequestIDs = message.payload.conversationID;

        this.sendSocketMessage(message);
        this.nextConversationsPageRequested = true;
    }


    requestNewConversation(participantID) {
        if (this.newConversationRequested) {
            return false;
        }
        let message = {};
        message.handler = "conversations";
        message.method = "newConversation";
        message.payload = {};
        message.payload.participantID = participantID;
        this.newConversationRequested = true;
        this.sendSocketMessage(message);
    }

    deleteConversationMessage(messageID, conversationId) {
        let message = {};
        message.handler = "conversations";
        message.method = "deleteConversationMessage";
        message.payload = {};
        message.payload.messageID = messageID;
        message.payload.conversationId = conversationId;
        this.sendSocketMessage(message);
        if (this.currentConversationID != null) {
            this.hideMessageActions();
        }
    }

    cancelPurchase(messageID) {
        let message = {};
        message.handler = "conversations";
        message.method = "cancelPurchase";
        message.payload = {};
        message.payload.messageID = messageID;
        this.sendSocketMessage(message);
    }

    setreadConversationMessage(messageID) {
        let message = {};
        message.handler = "conversations";
        message.method = "setreadConversationMessage";
        message.payload = {};
        message.payload.messageID = messageID;
        this.sendSocketMessage(message);
    }


    triggerNewSocketMessage(receiverID) {
        let message = {};
        message.type = "triggernewMessage";
        message.receiverID = receiverID;

        this.sendSocketMessage(message);
    }

    setmessagesRead(conversationID, maxMessageID) {
        return;
        let message = {};
        message.handler = "conversations";
        message.method = "setmessagesRead";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.maxMessageID = maxMessageID;

        this.sendSocketMessage(message);
    }


    triggerUserIsTyping(conversationID, content) {
        let message = {};
        message.handler = "conversations";
        message.method = "triggerUserIsTyping";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.content = content;
        this.sendSocketMessage(message);
    }

    sentNewMessage(conversationID, formData, currentMd5Hash) {
        let message = {};
        message.handler = "conversations";
        message.method = "newMessage";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.formData = formData;
        message.payload.currentMd5Hash = currentMd5Hash;
        message.payload.conversationSearchSequence = this.conversationSearchSequence;
        this.sendSocketMessage(message);
    }

    pinConversation() {
        let message = {};
        message.handler = "conversations";
        message.method = "pinConversation";
        message.payload = {};
        message.payload.conversationID = this.currentConversationID;
        this.sendSocketMessage(message);
    }

    unPinConversation() {
        let message = {};
        message.handler = "conversations";
        message.method = "unPinConversation";
        message.payload = {};
        message.payload.conversationID = this.currentConversationID;
        this.sendSocketMessage(message);
    }

    unreadConversation() {
        let message = {};
        message.handler = "conversations";
        message.method = "unreadConversation";
        message.payload = {};
        message.payload.conversationID = this.currentConversationID;
        this.sendSocketMessage(message);
    }

    deleteConversation() {
        let message = {};
        message.handler = "conversations";
        message.method = "deleteConversation";
        message.payload = {};
        message.payload.conversationID = this.currentConversationID;
        this.sendSocketMessage(message);
    }

    sentNewImage(conversationID, uploads, uploadMessage, uploadPrice, uploadCurrency, currentMd5Hash) {

        let formData = null;
        let $conversationHolder = $('#conversation_' + conversationID);

        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        if ($form.length == 1) {
            let $textarea = $form.find('textarea').first();
            if ($textarea.length == 1) {
                $textarea.val(uploadMessage);
            }
            formData = $form.serialize();
        }

        let message = {};
        message.handler = "conversations";
        message.method = "newMessage";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.uploads = uploads;
        message.payload.uploadPrice = uploadPrice;
        message.payload.uploadCurrency = uploadCurrency;
        message.payload.formData = formData;
        message.payload.currentMd5Hash = currentMd5Hash;
        message.payload.conversationSearchSequence = this.conversationSearchSequence;

        this.sendSocketMessage(message);
    }

    triggerUserStopTyping(conversationID) {
        let message = {};
        message.handler = "conversations";
        message.method = "triggerUserStopTyping";
        message.payload = {};
        message.payload.conversationID = conversationID;

        this.sendSocketMessage(message);
    }

    requestConversations(page) {
        let message = {};
        message.class = "Conversations";
        message.type = "getConversations";
        message.receiverID = receiverID;

        this.sendSocketMessage(message);
    }


    requestConversationData(conversationID, maxMessageID = null) {
        let message = {};
        message.handler = "conversations";
        message.method = "getConversationData";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.maxMessageID = maxMessageID;
        message.payload.conversationSearchSequence = this.conversationSearchSequence;
        this.sendSocketMessage(message);
    }

    requestSingleConversationListData(conversationID) {
        let message = {};
        message.handler = "conversations";
        message.method = "getSingleConversationsListData";
        message.payload = {};
        message.payload.conversationID = conversationID;
        this.sendSocketMessage(message);
    }


    requestPreviousMessages(conversationID, firstMessageID = null) {
        let message = {};
        message.handler = "conversations";
        message.method = "getPreviousMessages";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.firstMessageID = firstMessageID;
        message.payload.conversationSearchSequence = this.conversationSearchSequence;
        this.sendSocketMessage(message);
    }

    requestNextMessages(conversationID, lastMessageId) {
        let message = {};
        message.handler = "conversations";
        message.method = "getNextMessages";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.lastMessageId = lastMessageId;
        message.payload.conversationSearchSequence = this.conversationSearchSequence;
        this.sendSocketMessage(message);
    }

    createMessageReaction(messageId, reaction, conversationId) {
        let message = {};
        message.handler = "conversations";
        message.method = "createMessageReaction";
        message.payload = {};
        message.payload.messageId = messageId;
        message.payload.conversationId = conversationId;
        message.payload.reaction = reaction;
        this.sendSocketMessage(message);
    }

    handleClickedMessageReaction(messageId, clickedEmoji, conversationId) {
        let message = {};
        message.handler = "conversations";
        message.method = "handleClickedMessageReaction";
        message.payload = {};
        message.payload.messageId = messageId;
        message.payload.conversationId = conversationId;
        message.payload.reaction = clickedEmoji;
        this.sendSocketMessage(message);
    }

    sendGif(conversationId, sendTo, gif) {
        let formData = null;
        let $conversationHolder = $('#conversation_' + conversationId);

        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        if ($form.length == 1) {
            formData = $form.serialize();
        }

        let message = {};
        message.handler = "conversations";
        message.method = "newMessage";
        message.payload = {};
        message.payload.conversationId = conversationId;
        message.payload.sendTo = sendTo;
        message.payload.gif = gif;
        message.payload.formData = formData;

        let $textarea = $form.find('textarea').first();
        if ($textarea.length == 1) {
            $textarea.val('');
        }
        this.replyModeOff($conversationHolder);

        this.sendSocketMessage(message);
    }

    sendSocketMessage(message) {
        let mySelf = this;
        let messageAsString = JSON.stringify(message);

        if (this.connection === null || this.connection.readyState != 1 || this.connecting) {
            // hier könnte man nicht versendbare Messages in die Warteschleife setzen
            return;
        }
        this.connection.send(messageAsString);
    }

    getCurrentFullScreenElement() {
        if (document.fullscreenElement != null) {
            return document.fullscreenElement;
        } else if (document.mozFullScreenElement != null) {
            return document.mozFullScreenElement;
        } else if (document.webkitFullscreenElement != null) {
            return document.webkitFullscreenElement;
        } else if (document.msFullscreenElement != null) {
            return document.msFullscreenElement;
        }
        return null;
    }

}



